export const theme = {
  colors: {
    primary: '#0D7FE9', // Kovaion blue
    secondary: '#0A5DAB',
    background: '#FFFFFF',
    text: '#2D2D2D',
    lightGray: '#F2F2F2',
    lightBlue: '#E8F4FD',
    success: '#28a745',
    warning: '#ffc107',
    danger: '#dc3545',
  },
  fonts: {
    body: 'Arial, sans-serif',
    heading: 'Georgia, serif',
  },
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
  },
  breakpoints: {
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
  },
};
